import Reflux from 'reflux';

const AuditLogActions = Reflux.createActions({
  status: { asyncResult: true },
  entriesPaginated: { asyncResult: true },
  searchPaginated: { asyncResult: true },
});

export default AuditLogActions;
